import TEST from "../../utils/keywords"

export const titles = {
  [TEST.UPDTAE_BLOG_STATUS]: "Update Blog Status",
  [TEST.UPDTAE_FORUM_STATUS]: "Update Forum Status",
  [TEST.UPDATE_MEMBER_STATUS]: "Block User Account",
  [TEST.UPDATE_WEBINAR_STATUS]: "Update Webinar Status",
  [TEST.UPDATE_SPECIALIST_STATUS]: "Block User Account",
  [TEST.DISABLE_USER_STATUS]: "Block User Account",
}

export const messages = {
  [TEST.UPDTAE_BLOG_STATUS]: "Warning: You are about to change the blog status. Are you sure you want to proceed?",
  [TEST.UPDTAE_FORUM_STATUS]: "Warning: You are about to change the forum status. Are you sure you want to proceed?",
  [TEST.UPDATE_WEBINAR_STATUS]: "Warning: You are about to change the webinar status. Are you sure you want to proceed?",
  [TEST.UPDATE_SPECIALIST_STATUS]: "Warning: Are you sure you want to block this user's account? This action will immediately restrict their access. Are you sure you want to proceed?",
  [TEST.UPDATE_MEMBER_STATUS]: "Warning: Are you sure you want to block this user's account? This action will immediately restrict their access. Are you sure you want to proceed?",
  [TEST.DISABLE_USER_STATUS]: "Warning: Are you sure you want to block this user's account? This action will immediately restrict their access. Are you sure you want to proceed?",
}

export const btnText = {
  [TEST.DISABLE_USER_STATUS]: "Block",
}